<div class="agpr-individualRecipientReport-container">
    <div class="agpr-individualRecipientReport-header-container">
        <div class="agpr-individualRecipientReport-header">
            @if (data.recipientName) {
                <span class="agpr-individualRecipientReport-header-text">
                    {{ data.recipientName }}
                </span>
            }
            @if (!data.recipientName && !data.isStandaloneRecipient && !data.listId && !data.searchId) {
                <span class="agpr-individualRecipientReport-header-text">
                    {{ 'Discover.distribution.deleted' | localize }}
                </span>
            }
            @if (!data.recipientName && data.isStandaloneRecipient) {
                <span class="agpr-individualRecipientReport-header-text">
                    {{ 'Discover.distribution.individualRecipients' | localize }}
                </span>
            }
            @if (!data.isRecommendedRecipient && !data.recipientName && !data.isStandaloneRecipient && (data.listId || data.searchId)) {
                <span class="agpr-individualRecipientReport-header-text">
                    {{ 'Discover.distribution.individualRecipients' | localize }}
                </span>
            }
            @if (data.isRecommendedRecipient && !data.recipientName && (data.listId || data.searchId)) {
                <span class="agpr-individualRecipientReport-header-text">
                    {{ 'Discover.distribution.rrRecipients' | localize }}
                </span>
            }

            <span class="agpr-individualRecipientReport-header-rightSide">
                <span class="agpr-individualRecipientReport-header-text-value">
                    {{ data.recipientCount }}
                </span>
            </span>
        </div>
    </div>

    <div class="agpr-individualRecipientReport-grid-container">
        <div
            class="agpr-individualRecipientReport-grid-row"
            [ngClass]="{'agpr-individualRecipientReport-grid-row-selected' :
                selectedType === statTypes.SENT && selectedIndividualRecipient === data
            }"
            (agprClickUnless)="selectStatType(statTypes.SENT)"
            tabindex="0"
            (keydown)="statCardKeydown($event, statTypes.SENT)"
        >
            <div
                class="agpr-individualRecipientReport-grid-bar"
                [ngClass]="{ 'agpr-individualRecipientReport-grid-bar--selected': selectedItem === statTypes.SENT }"
            ></div>
            <div class="agpr-individualRecipientReport-grid-row-item">
                {{ 'Discover.distributionReport.recipient.statsType.sent' | localize }}
            </div>
            <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.sentCount | number }} </div>
            <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.sentRatio | percent }} </div>
            <div class="agpr-individualRecipientReport-grid-row-item agpr-individualRecipientReport-grid-row-item-progressbar">
                <p-progressBar
                    [value]="data.sentRatio * 100"
                    [showValue]="false"
                ></p-progressBar>
            </div>
            <div class="agpr-individualRecipientReport-grid-row-item">
                <!--- TODO: get a real value +1% -->
            </div>
        </div>

        <div
            class="agpr-individualRecipientReport-grid-row"
            [ngClass]="{'agpr-individualRecipientReport-grid-row-selected' :
                selectedType === statTypes.DELIVERED && selectedIndividualRecipient === data
            }"
            (agprClickUnless)="selectStatType(statTypes.DELIVERED)"
            tabindex="0"
            (keydown)="statCardKeydown($event, statTypes.DELIVERED)"
        >
            <div
                class="agpr-individualRecipientReport-grid-bar"
                [ngClass]="{ 'agpr-individualRecipientReport-grid-bar--selected': selectedItem === statTypes.DELIVERED }"
            ></div>
            <div class="agpr-individualRecipientReport-grid-row-item">
                {{ 'Discover.distributionReport.recipient.statsType.delivered' | localize }}
            </div>
            <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.deliveredCount | number }} </div>
            <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.deliveredRatio | percent }} </div>
            <div class="agpr-individualRecipientReport-grid-row-item agpr-individualRecipientReport-grid-row-item-progressbar">
                <p-progressBar
                    [value]="data.deliveredRatio * 100"
                    [showValue]="false"
                ></p-progressBar>
            </div>
            <div class="agpr-individualRecipientReport-grid-row-item">
                <div
                    [ngClass]="{
                        'agpr-individualRecipientReport-grid-row-item-benchmarkDifference': true,
                        'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--positive': deliveredRatioPercentageChangeFromBenchmark > 0,
                        'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--negative': deliveredRatioPercentageChangeFromBenchmark < 0,
                        'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--neutral': deliveredRatioPercentageChangeFromBenchmark  === 0 || deliveredRatioPercentageChangeFromBenchmark  === null,
                        'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--empty': recipientReportData?.isBriefingReport
                    }"
                    [agprTooltip]="deliveredRatioTooltip | localize"
                >
                    @if (deliveredRatioPercentageChangeFromBenchmark > 0) {
                        <span class="fa-arrow-up-right fa-regular "></span>
                    }
                    @if (deliveredRatioPercentageChangeFromBenchmark < 0) {
                        <span class="fa-arrow-down-right fa-regular  "></span>
                    }
                    {{ deliveredRatioPercentageChangeFromBenchmark + ' %' }}
                </div>
            </div>
        </div>

        @if (!openTracking) {
            <div class="agpr-individualRecipientReport-grid-row">
                <div class="agpr-individualRecipientReport-grid-bar"></div>
                <div class="agpr-individualRecipientReport-grid-row-item">
                    {{'Discover.distributionReport.recipient.statsType.uniqueOpens' | localize}}
                </div>
                <div
                    class="agpr-individualRecipientReport-grid-row-item agpr-individualRecipientReport-trackingDisabled"
                    [pTooltip]="openTracking ? null : ('Discover.distributionReport.tracking.openDisabled' | localize)"
                    tooltipPosition="top"
                >
                    {{ 'N/A' | localize }}
                </div>
            </div>
        }
        @if (openTracking) {
            <div
                class="agpr-individualRecipientReport-grid-row"
                [ngClass]="{'agpr-individualRecipientReport-grid-row-selected' :
                    selectedType === statTypes.UNIQUE_OPEN && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.UNIQUE_OPEN)"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.UNIQUE_OPEN)"
            >
                <div
                    class="agpr-individualRecipientReport-grid-bar"
                    [ngClass]="{ 'agpr-individualRecipientReport-grid-bar--selected': selectedItem === statTypes.UNIQUE_OPEN }">
                </div>
                <div class="agpr-individualRecipientReport-grid-row-item">
                    {{ 'Discover.distributionReport.recipient.statsType.uniqueOpens' | localize }}</div>
                <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.uniqueOpenCount | number }} </div>
                <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.uniqueOpenRatio | percent }} </div>
                <div class="agpr-individualRecipientReport-grid-row-item agpr-individualRecipientReport-grid-row-item-progressbar">
                    <p-progressBar
                        [value]="data.uniqueOpenRatio * 100"
                        [showValue]="false"
                    ></p-progressBar>
                </div>
                <div class="agpr-individualRecipientReport-grid-row-item">
                    <div
                        [ngClass]="{
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference': true,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--positive': uniqueOpenRatioPercentageChangeFromBenchmark > 0,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--negative': uniqueOpenRatioPercentageChangeFromBenchmark < 0,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--neutral': uniqueOpenRatioPercentageChangeFromBenchmark  === 0 || uniqueOpenRatioPercentageChangeFromBenchmark  === null,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--empty': recipientReportData?.isBriefingReport
                        }"
                        [agprTooltip]="uniqueOpenRatioTooltip | localize"
                    >
                        @if (uniqueOpenRatioPercentageChangeFromBenchmark > 0) {
                            <span class="fa-arrow-up-right fa-regular"></span>
                        }
                        @if (uniqueOpenRatioPercentageChangeFromBenchmark < 0) {
                            <span class="fa-arrow-down-right fa-regular"></span>
                        }
                        {{ uniqueOpenRatioPercentageChangeFromBenchmark + ' %' }}
                    </div>
                </div>
            </div>
        }

        @if (!clickTracking) {
            <div class="agpr-individualRecipientReport-grid-row">
                <div class="agpr-individualRecipientReport-grid-bar"></div>
                <div class="agpr-individualRecipientReport-grid-row-item">
                    {{'Discover.distributionReport.recipient.statsType.uniqueClicks' | localize}}
                </div>
                <div
                class="agpr-individualRecipientReport-grid-row-item agpr-individualRecipientReport-trackingDisabled"
                    [pTooltip]="clickTracking ? null : ('Discover.distributionReport.tracking.clickDisabled' | localize)"
                    tooltipPosition="top"
                    >
                    {{'N/A' | localize}}
                </div>
            </div>
        }
        @if (clickTracking) {
            <div
                class="agpr-individualRecipientReport-grid-row"
                [ngClass]="{'agpr-individualRecipientReport-grid-row-selected' :
                    selectedType === statTypes.UNIQUE_CLICKS && selectedIndividualRecipient === data
                }"
                (agprClickUnless)="selectStatType(statTypes.UNIQUE_CLICKS)"
                tabindex="0"
                (keydown)="statCardKeydown($event, statTypes.UNIQUE_CLICKS)"
            >
                <div
                    class="agpr-individualRecipientReport-grid-bar"
                    [ngClass]="{ 'agpr-individualRecipientReport-grid-bar--selected': selectedItem === statTypes.UNIQUE_CLICKS }"
                ></div>
                <div class="agpr-individualRecipientReport-grid-row-item">
                    {{ 'Discover.distributionReport.recipient.statsType.uniqueClicks' | localize }}</div>
                <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.uniqueClickCount | number }} </div>
                <div class="agpr-individualRecipientReport-grid-row-item centered"> {{ data.uniqueClickRatio | percent }} </div>
                <div class="agpr-individualRecipientReport-grid-row-item agpr-individualRecipientReport-grid-row-item-progressbar">
                    <p-progressBar
                        [value]="data.uniqueClickRatio * 100"
                        [showValue]="false"
                    ></p-progressBar>
                </div>
                <div class="agpr-individualRecipientReport-grid-row-item">
                    <div
                        [ngClass]="{
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference': true,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--positive': uniqueClickRatioPercentageChangeFromBenchmark > 0,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--negative': uniqueClickRatioPercentageChangeFromBenchmark < 0,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--neutral': uniqueClickRatioPercentageChangeFromBenchmark  === 0 || uniqueClickRatioPercentageChangeFromBenchmark  === null,
                            'agpr-individualRecipientReport-grid-row-item-benchmarkDifference--empty': recipientReportData?.isBriefingReport
                        }"
                        [agprTooltip]="uniqueClickRatioTooltip | localize"
                    >
                    @if (uniqueClickRatioPercentageChangeFromBenchmark > 0) {
                        <span class="fa-arrow-up-right fa-regular "></span>
                    }
                    @if (uniqueClickRatioPercentageChangeFromBenchmark < 0) {
                        <span class="fa-arrow-down-right fa-regular "></span>
                    }
                    {{ uniqueClickRatioPercentageChangeFromBenchmark + ' %' }}
                </div>
            </div>
            </div>
        }
        <div tabindex="0" class="agpr-individualRecipientReport-additionalInfo" (click)="expanded = !expanded"
            (keydown.enter)="expanded = !expanded"
            [attr.aria-expanded]="expanded"
        >
            <div class="agpr-individualRecipientReport-grid-row-item-additionalInfo">
                {{ 'Discover.distribution.additionalInfo' | localize }}
            </div>
            <span
                [class]="'agpr-individualRecipientReport-additionalInfo-icon ' + (expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down')"
                role="img">
            </span>
        </div>

        @if (expanded) {
            <agpr-undesirables-report [data]="data" (statTypeSelected)="selectStatType($event?.statType)"
                [selectedIndividualRecipient]='selectedIndividualRecipient'>
            </agpr-undesirables-report>
        }
    </div>
</div>
